// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1t4Xx{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;bottom:32px;bottom:3.2rem;color:#452aec;font-size:14px;font-size:1.4rem;position:absolute}html[dir=ltr] ._1t4Xx{right:32px;right:3.2rem}html[dir=rtl] ._1t4Xx{left:32px;left:3.2rem}._2YGgd{color:#3f9fff!important;font-size:16px;font-weight:500;line-height:24px;text-align:center}._1wuhf{margin:16px 0 0}._37MuW{fill:none;height:22px;height:2.2rem;stroke:#452aec;stroke-width:1px;width:22px;width:2.2rem}html[dir=ltr] ._37MuW{margin-right:.6rem}html[dir=rtl] ._37MuW{margin-left:.6rem}", ""]);
// Exports
exports.locals = {
	"link": "_1t4Xx",
	"linkAsText": "_2YGgd",
	"linkAsText__text": "_1wuhf",
	"link__icon": "_37MuW"
};
module.exports = exports;
